import React from "react";
import "./Solution.css"; // Import CSS file

const solutions = [
  {
    icon: "bi bi-droplet-half",
    title: "Water Management",
    description:
      "Smart monitoring of water levels, pressure, and flow using advanced transmitters and IoT integration for efficient water distribution and leak detection.",
    link: "#",
  },
  {
    icon: "bi bi-cpu-fill",
    title: "PLC Solutions",
    description:
      "Reliable automation with programmable logic controllers for industrial machines, ensuring high performance, flexibility, and safety in operations.",
    link: "#",
  },
  {
    icon: "bi bi-wifi",
    title: "IoT & IIoT",
    description:
      "Seamless connectivity of devices and sensors, enabling real-time data collection, predictive maintenance, and smart decision-making for industries.",
    link: "#",
  },
  {
    icon: "bi bi-bar-chart-fill",
    title: "SCADA & HMI",
    description:
      "Comprehensive visualization and control through SCADA & HMI systems for monitoring processes, alarms, and enhancing operator efficiency.",
    link: "#",
  },
];

const Solution = () => {
  return (
    <section id="solutions" className="solutions-section py-5">
      <div className="container">
        <h2 className="text-center fw-bold mb-5 text-primary">Our Solutions</h2>
        <div className="row g-4">
          {solutions.map((solution, index) => (
            <div key={index} className="col-md-6 col-lg-3">
              <div className="solution-card h-100">
                <div className="icon-box">
                  <i className={solution.icon}></i>
                </div>
                <h4>{solution.title}</h4>
                <p>{solution.description}</p>
                <a href={solution.link} className="btn btn-outline-primary btn-sm">
                  Learn More
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solution;
